import * as AdminUsersModule from './index';

export const Admin_AllUsers = {
  path: '/admin/allusers',
  name: 'AdminAllUsers',
  component: AdminUsersModule.AdminAllUsers,
};
